import React, { useContext } from 'react';

import { CardContext, ICardContext } from 'context/cardContext';
import './CardMatchHasStarted.scss';

const CardMatchHasStarted = () => {
  const { eventParticipants, participantCodeOne, eventHomeScore, participantCodeTwo, eventAwayScore, countDownText, isFullTime } = useContext<ICardContext>(CardContext);

  if (!eventParticipants) return null;

  return (
    <div className={`card-match-has-started ${!isFullTime ? 'card-match-has-started--in-play' : ''}`}>
      <div className="card-match-has-started__score-container">
        <span className="card-match-has-started__team">{participantCodeOne}</span>
        <span className="card-match-has-started__score">
          {eventHomeScore !== null ? eventHomeScore : 0} - {eventAwayScore !== null ? eventAwayScore : 0}
        </span>
        <span className="card-match-has-started__team">{participantCodeTwo}</span>
      </div>
      {/* Hack to balance counter since the "`" makes it look unbalanced */}
      <div className="card-match-has-started__counter" style={{ marginRight: isFullTime ? 0 : '-6px' }}>
        {countDownText}
      </div>
    </div>
  );
};

export default CardMatchHasStarted;
